module.exports = __webpack_public_path__ + "img/ic24City.4813e7ad.svg";